module.exports = __webpack_public_path__ + "static/media/Group 10386 (1).ce426bb5.svg";